<script setup lang="ts">
export interface Crumb {
  label: string
  to?: string
}

defineProps<{
  title?: string
  subtitle?: string
  breadcrumb?: Crumb[]
}>()
</script>

<template>
  <header class="sticky top-0 z-10 border-b border-line/90 bg-panel/75 backdrop-blur-xl">
    <div class="flex flex-wrap items-end justify-between gap-3 px-8 py-4">
      <div class="min-w-0">
        <nav
          v-if="breadcrumb && breadcrumb.length > 0"
          aria-label="面包屑"
          class="mb-1.5 flex items-center gap-1.5 text-[12px]"
        >
          <span v-for="(c, i) in breadcrumb" :key="`${c.label}-${i}`" class="flex items-center gap-1.5">
            <span v-if="i > 0" class="text-line-strong">/</span>
            <RouterLink v-if="c.to" :to="c.to" class="text-link hover:underline">{{ c.label }}</RouterLink>
            <span v-else class="text-dim">{{ c.label }}</span>
          </span>
        </nav>
        <h1 class="truncate text-[22px] font-semibold tracking-tight text-text">
          <slot name="title">{{ title }}</slot>
        </h1>
        <p v-if="subtitle || $slots.subtitle" class="mt-1 max-w-2xl text-[13px] text-muted">
          <slot name="subtitle">{{ subtitle }}</slot>
        </p>
      </div>
      <div v-if="$slots.actions" class="flex flex-wrap items-center gap-2 pb-0.5">
        <slot name="actions" />
      </div>
    </div>
  </header>
</template>
